import React, { useState } from 'react';
import { useData } from '../../store/DataContext';
import { Card } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { Input } from '../../components/ui/Input';
import { Search, UserPlus, Users, User } from 'lucide-react';
export const Customers: React.FC = () => {
  const {
    patients,
    walkInClients,
    addWalkInClient,
    logBillingAudit
  } = useData();
  const [activeTab, setActiveTab] = useState<'registered' | 'walkin'>('registered');
  const [searchQuery, setSearchQuery] = useState('');
  const [showAddWalkIn, setShowAddWalkIn] = useState(false);
  const [walkInForm, setWalkInForm] = useState({
    name: '',
    phone: '',
    nrcPassport: '',
    email: '',
    address: ''
  });
  const filteredPatients = patients.filter(p => p.firstName.toLowerCase().includes(searchQuery.toLowerCase()) || p.lastName.toLowerCase().includes(searchQuery.toLowerCase()) || p.bmcFileNumber.toLowerCase().includes(searchQuery.toLowerCase()) || p.contact.includes(searchQuery));
  const filteredWalkIns = walkInClients.filter(c => c.name.toLowerCase().includes(searchQuery.toLowerCase()) || c.phone && c.phone.includes(searchQuery) || c.nrcPassport && c.nrcPassport.toLowerCase().includes(searchQuery.toLowerCase()));
  const handleAddWalkIn = (e: React.FormEvent) => {
    e.preventDefault();
    const newClient = addWalkInClient(walkInForm);
    logBillingAudit('Create Walk-in Client', `Created walk-in client ${newClient.name}`);
    setShowAddWalkIn(false);
    setWalkInForm({
      name: '',
      phone: '',
      nrcPassport: '',
      email: '',
      address: ''
    });
    setActiveTab('walkin');
  };
  return <div className="space-y-6" data-id="element-1188" data-mp="1qhci52aobke8">
      <div className="flex justify-between items-center" data-id="element-1189" data-mp="25br6lid0bm0a">
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-1190" data-mp="25a6bnrms611w">Customers</h1>
        <Button onClick={() => setShowAddWalkIn(true)} data-id="element-1191" data-mp="20eh4p38flhvk">
          <UserPlus className="w-4 h-4 mr-2" data-id="element-1192" data-mp="27gntfvej4zmi" /> New Walk-in Client
        </Button>
      </div>

      <Card noPadding data-id="element-1193" data-mp="2cf7frwx1cdfe">
        <div className="border-b border-gray-200" data-id="element-1194" data-mp="2cepcigbygyxz">
          <nav className="flex -mb-px" data-id="element-1195" data-mp="2cde4237kf30j">
            <button onClick={() => setActiveTab('registered')} className={`w-1/2 py-4 px-1 text-center border-b-2 font-medium text-sm ${activeTab === 'registered' ? 'border-blue-500 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-1196" data-mp="2hea9wmbh8z8l">
              <Users className="w-5 h-5 inline-block mr-2" data-id="element-1197" data-mp="2v4nh2mgjo9wv" />
              Registered Patients ({patients.length})
            </button>
            <button onClick={() => setActiveTab('walkin')} className={`w-1/2 py-4 px-1 text-center border-b-2 font-medium text-sm ${activeTab === 'walkin' ? 'border-blue-500 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-1198" data-mp="302yut89yn4kd">
              <User className="w-5 h-5 inline-block mr-2" data-id="element-1199" data-mp="136m20yzj4yt1" />
              Walk-in Clients ({walkInClients.length})
            </button>
          </nav>
        </div>

        <div className="p-4 border-b border-gray-200 bg-gray-50" data-id="element-1200" data-mp="yeay7l1o4sv7">
          <div className="relative max-w-md" data-id="element-1201" data-mp="tfzttpu57akd">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-1202" data-mp="teoovmoynwro">
              <Search className="h-5 w-5 text-gray-400" data-id="element-1203" data-mp="ofljg152joj6" />
            </div>
            <input type="text" className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md leading-5 bg-white placeholder-gray-500 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 sm:text-sm" placeholder="Search customers..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-1204" data-mp="1m4ybklucsap5" />
          </div>
        </div>

        <div className="overflow-x-auto" data-id="element-1205" data-mp="3ryoj3qfru0dr">
          <table className="min-w-full divide-y divide-gray-200" data-id="element-1206" data-mp="3rxn8to6kxhx3">
            <thead className="bg-gray-50" data-id="element-1207" data-mp="1kmokt95eepf6">
              <tr data-id="element-1208" data-mp="1klnax804c8z1">
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1209" data-mp="1kl563mze4mfi">
                  {activeTab === 'registered' ? 'BMC Number' : 'Client ID'}
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1210" data-mp="1an7j12t9ovoh">
                  Name
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1211" data-mp="23f0ukgydsszc">
                  Contact
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1212" data-mp="1tfs43y2q5whq">
                  {activeTab === 'registered' ? 'Age/Sex' : 'NRC/Passport'}
                </th>
                <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1213" data-mp="hzv3vdpfrq57">
                  Action
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200" data-id="element-1214" data-mp="316pfbr5dnh4n">
              {activeTab === 'registered' ? filteredPatients.length > 0 ? filteredPatients.map(patient => <tr key={patient.id} className="hover:bg-gray-50" data-id="element-1215" data-mp="3a6vr98lfg91p">
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-blue-600" data-id="element-1216" data-mp="366lad0w3jy82">
                        {patient.bmcFileNumber}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-1217" data-mp="2ied229d6qvfq">
                        {patient.firstName} {patient.lastName}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-1218" data-mp="2rb5mxeq0v0kn">
                        {patient.contact}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-1219" data-mp="1yrow91nsz230">
                        {patient.age} / {patient.sex}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-1220" data-mp="3tw6crqug3afn">
                        <Button variant="outline" size="sm" data-id="element-1221" data-mp="2pc2d2duotlw">
                          Create Invoice
                        </Button>
                      </td>
                    </tr>) : <tr data-id="element-1222" data-mp="cedeuil6ssv4">
                    <td colSpan={5} className="px-6 py-12 text-center text-gray-500" data-id="element-1223" data-mp="cevi3z69o7cj">
                      No registered patients found.
                    </td>
                  </tr> : filteredWalkIns.length > 0 ? filteredWalkIns.map(client => <tr key={client.id} className="hover:bg-gray-50" data-id="element-1224" data-mp="3pul4kisuvkbs">
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-500" data-id="element-1225" data-mp="104znoc30mh66">
                      {client.id.split('-')[1]}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-1226" data-mp="1529dhsubguuj">
                      {client.name}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-1227" data-mp="2ko350h9eloee">
                      {client.phone || '—'}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-1228" data-mp="2ftyy1y051gdb">
                      {client.nrcPassport || '—'}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-1229" data-mp="25zp4we3dge1j">
                      <Button variant="outline" size="sm" data-id="element-1230" data-mp="21vr1vsaxej37">
                        Create Invoice
                      </Button>
                    </td>
                  </tr>) : <tr data-id="element-1231" data-mp="1s07anj7b48ks">
                  <td colSpan={5} className="px-6 py-12 text-center text-gray-500" data-id="element-1232" data-mp="1s0phtavic77h">
                    No walk-in clients found.
                  </td>
                </tr>}
            </tbody>
          </table>
        </div>
      </Card>

      {/* Add Walk-in Client Modal */}
      {showAddWalkIn && <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" data-id="element-1233" data-mp="305cuh2caul4l">
          <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-6" data-id="element-1234" data-mp="2lgykm7ggtwej">
            <h3 className="text-lg font-bold text-gray-900 mb-4" data-id="element-1235" data-mp="2qf0957wnunxe">
              New Walk-in Client
            </h3>
            <form onSubmit={handleAddWalkIn} className="space-y-4" data-id="element-1236" data-mp="2cf8s0yaukrf6">
              <Input label="Full Name" required value={walkInForm.name} onChange={e => setWalkInForm({
            ...walkInForm,
            name: e.target.value
          })} data-id="element-1237" data-mp="2hgoaqjpjylue" />
              <Input label="Phone Number (Optional)" value={walkInForm.phone} onChange={e => setWalkInForm({
            ...walkInForm,
            phone: e.target.value
          })} data-id="element-1238" data-mp="riu7dl5s9pf" />
              <Input label="NRC/Passport (Optional)" value={walkInForm.nrcPassport} onChange={e => setWalkInForm({
            ...walkInForm,
            nrcPassport: e.target.value
          })} data-id="element-1239" data-mp="1lav1ab8rqgq9" />
              <Input label="Email (Optional)" type="email" value={walkInForm.email} onChange={e => setWalkInForm({
            ...walkInForm,
            email: e.target.value
          })} data-id="element-1240" data-mp="290gxcptugfu1" />
              <Input label="Address (Optional)" value={walkInForm.address} onChange={e => setWalkInForm({
            ...walkInForm,
            address: e.target.value
          })} data-id="element-1241" data-mp="ohzknzn23d5i" />
              <div className="flex justify-end space-x-3 mt-6" data-id="element-1242" data-mp="2c683z3hd6p64">
                <Button variant="outline" type="button" onClick={() => setShowAddWalkIn(false)} data-id="element-1243" data-mp="2786jce4aihsj">
                  Cancel
                </Button>
                <Button type="submit" data-id="element-1244" data-mp="2zxdinfbkjbeu">Save Client</Button>
              </div>
            </form>
          </div>
        </div>}
    </div>;
};